module.exports = __webpack_public_path__ + "img/phone_mockup.3b560d2d.svg";